import { pageTitle } from 'ember-page-title';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';

<template>
  {{pageTitle (t "services.title") separator=" | "}}

  {{! Page Header }}
  <section class="page-header" aria-labelledby="services-title">
    <div class="container">
      <div class="section-header">
        <h1 id="services-title" class="section-header__title">{{t
            "services.title"
          }}</h1>
        <p class="section-header__description">
          {{t "services.subtitle"}}
        </p>
      </div>
    </div>
  </section>

  {{! Semantic Web Services }}
  <section class="section" aria-labelledby="semantic-web-title">
    <div class="container">
      <div class="services-grid">
        <div>
          <h2 id="semantic-web-title">{{t "services.semantic_web.title"}}</h2>
          <p>
            {{t "services.semantic_web.description"}}
          </p>
          <ul>
            <li><strong>{{t "services.semantic_web.rdf_linked_data"}}</strong>
              {{t "services.semantic_web.rdf_linked_data_desc"}}</li>
            <li><strong>{{t "services.semantic_web.sparql"}}</strong>
              {{t "services.semantic_web.sparql_desc"}}</li>
            <li><strong>{{t "services.semantic_web.ontology"}}</strong>
              {{t "services.semantic_web.ontology_desc"}}</li>
            <li><strong>{{t "services.semantic_web.data_modeling"}}</strong>
              {{t "services.semantic_web.data_modeling_desc"}}</li>
            <li><strong>{{t "services.semantic_web.reasoning"}}</strong>
              {{t "services.semantic_web.reasoning_desc"}}</li>
            <li><strong>{{t "services.semantic_web.standards"}}</strong>
              {{t "services.semantic_web.standards_desc"}}</li>
          </ul>
        </div>
        <div class="card">
          <h3 class="card__title">{{t
              "services.semantic_web.tech_card_title"
            }}</h3>
          <ul class="mb-0">
            <li>{{t "services.semantic_web.tech_rdf"}}</li>
            <li>{{t "services.semantic_web.tech_sparql"}}</li>
            <li>{{t "services.semantic_web.tech_owl"}}</li>
            <li>{{t "services.semantic_web.tech_skos"}}</li>
            <li>{{t "services.semantic_web.tech_schema"}}</li>
            <li>{{t "services.semantic_web.tech_dublin"}}</li>
            <li>{{t "services.semantic_web.tech_triplestore"}}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  {{! AI/ML Services }}
  <section class="section section--alt" aria-labelledby="ai-ml-title">
    <div class="container">
      <div class="services-grid">
        <div>
          <h2 id="ai-ml-title">{{t "services.ai_ml.title"}}</h2>
          <p>
            {{t "services.ai_ml.description"}}
          </p>
          <ul>
            <li><strong>{{t "services.ai_ml.knowledge_extraction"}}</strong>
              {{t "services.ai_ml.knowledge_extraction_desc"}}</li>
            <li><strong>{{t "services.ai_ml.deep_learning"}}</strong>
              {{t "services.ai_ml.deep_learning_desc"}}</li>
            <li><strong>{{t "services.ai_ml.data_science"}}</strong>
              {{t "services.ai_ml.data_science_desc"}}</li>
            <li><strong>{{t "services.ai_ml.integration"}}</strong>
              {{t "services.ai_ml.integration_desc"}}</li>
          </ul>
        </div>
        <div class="card">
          <h3 class="card__title">{{t "services.ai_ml.cert_card_title"}}</h3>
          <ul class="mb-0">
            <li>{{t "services.ai_ml.cert_ml"}}</li>
            <li>{{t "services.ai_ml.cert_nn"}}</li>
            <li>{{t "services.ai_ml.cert_ds"}}</li>
            <li>{{t "services.ai_ml.cert_structuring"}}</li>
            <li>{{t "services.ai_ml.cert_hyperparameter"}}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  {{! Data Engineering & Management }}
  <section class="section" aria-labelledby="data-engineering-title">
    <div class="container">
      <div class="services-grid">
        <div>
          <h2 id="data-engineering-title">{{t
              "services.data_engineering.title"
            }}</h2>
          <p>
            {{t "services.data_engineering.description"}}
          </p>
          <ul>
            <li><strong>{{t "services.data_engineering.data_analysis"}}</strong>
              {{t "services.data_engineering.data_analysis_desc"}}</li>
            <li><strong>{{t
                  "services.data_engineering.software_engineering"
                }}</strong>
              {{t "services.data_engineering.software_engineering_desc"}}</li>
            <li><strong>{{t
                  "services.data_engineering.product_ownership"
                }}</strong>
              {{t "services.data_engineering.product_ownership_desc"}}</li>
            <li><strong>{{t "services.data_engineering.healthcare_it"}}</strong>
              {{t "services.data_engineering.healthcare_it_desc"}}</li>
          </ul>
        </div>
        <div class="card">
          <h3 class="card__title">{{t
              "services.data_engineering.approach_card_title"
            }}</h3>
          <p class="mb-0">
            {{t "services.data_engineering.approach_text"}}
          </p>
        </div>
      </div>
    </div>
  </section>

  {{! CTA }}
  <section class="section section--accent" aria-labelledby="cta-title">
    <div class="container text-center">
      <h2 id="cta-title">{{t "services.cta.title"}}</h2>
      <p class="cta__description">
        {{t "shared.fully_booked"}}
      </p>
      <LinkTo @route="contact" class="btn btn--primary">
        {{t "services.cta.button"}}
      </LinkTo>
    </div>
  </section>
</template>
